































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { useFiservDebitCardsStore } from "@/shared/store/fiservDebitCards";
import { useNotifierStore } from "@/shared/store/notifier";

@Component({
  components: {
  }
})
export default class FiservDebitCardAddDependentModal extends Vue {

  notifierStore = useNotifierStore();
  fiserveDebitCardsStore = useFiservDebitCardsStore();


  get modalOpen () {
    return this.fiserveDebitCardsStore.fiservDebitCardDependentModalOpen;
  }
  set modalOpen (value: boolean) {
    this.fiserveDebitCardsStore.setDependentModalOpen(value);
  }

  firstName = "";
  lastName = "";

  userHasTouchedFirstNameInput = false;
  userHasTouchedLastNameInput = false;
  formIsBeingSubmitted = false;

  firstNameBlurred () {
    this.$validator.validateAll();
    this.userHasTouchedFirstNameInput = true;
  }

  validateFirstNameState (ref) {
    if (this.userHasTouchedFirstNameInput) {
      return !this.errors.has(ref);
    }
    return null;
  }

  lastNameBlurred () {
    this.$validator.validateAll();
    this.userHasTouchedLastNameInput = true;
  }

  validateLastNameState (ref) {
    if (this.userHasTouchedLastNameInput) {
      return !this.errors.has(ref);
    }
    return null;
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();

    this.firstNameBlurred();
    this.lastNameBlurred();

    this.$validator.validateAll()
      .then(isValid => {
        if (this.formIsBeingSubmitted || !isValid) {
          return;
        }
        this.formIsBeingSubmitted = true;

        this.fiserveDebitCardsStore.addFiservDebitCardDependent({
        firstName: this.firstName,
        lastName: this.lastName})
        .then(() => {
          this.notifierStore.setSuccess(`Dependent card requested`);

          // Hide the modal manually
          this.fiserveDebitCardsStore.setDependentModalOpen(false);
        })
        .catch(() => {
          this.notifierStore.setDanger(`There was an issue contacting our card provider. Please try again later.`);
          this.formIsBeingSubmitted = false;
        });
    });
  }

}
